export default {

    state: {
        darkMode: false,
        quickLinks: [ 
            { label: 'Quick Link 1', url: '#'},
            { label: 'Quick Link 2', url: '#'},
            { label: 'Quick Link 3', url: '#'}
        ]
    },

    getters: { 
        getQuickLinks(state) {
            return state.quickLinks
        }
    },

    // actions: {

    // },

    mutations: {
        SET_QUICK_LINKS(state, quickLinks) {
            state.quickLinks = quickLinks
        }
    }
}
